import { db } from "../config/firebase";

import StoreCard from "./StoreCard";
import { Row, Spinner, Container, Col, Form } from "react-bootstrap";

import { useQuery } from "react-query";
import { useState } from "react";

const StoresList = (props) => {
  const location = props.location;

  const fetchAPI = async () => {
    let dbStores = [];
    let dbStores2 = [];

    try {
      await db
        .collection("stores")
        .where("codesCount", ">", 0)
        .get()
        .then((snapshot) => {
          snapshot.forEach((storeF) => {
            let storeWithID = { ...storeF.data(), id: storeF.id };
            dbStores = [...dbStores, storeWithID];
          });
        });
    } catch (error) {
      console.log(error.message);
    }
    if (
      !(
        location.country === "SA" ||
        location.country === "AE" ||
        location.country === "KW" ||
        location.country === "OM" ||
        location.country === "QA" ||
        location.country === "BH"
      )
    ) {
      dbStores2 = dbStores.filter((s) => s.slug !== "iherb");
      return dbStores2;
    } else {
      return dbStores;
    }
  };

  const { isLoading, error, data: stores } = useQuery("stores", fetchAPI);

  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const contains = (ar, en, search) => {
    en = en.toLowerCase();
    if (ar.includes(search) || en.includes(search)) {
      return true;
    }
    return false;
  };

  const searchHandler = async (e) => {
    setSearch(e.target.value);
    let stores2 = stores.filter((s) =>
      contains(s.nameAr, s.nameEn, e.target.value.toLowerCase())
    );
    setSearchResult(stores2);
  };

  if (isLoading) {
    return (
      <Container className="mx-auto my-5 d-flex justify-content-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (error) return "An error has occurred: " + error.message;

  return (
    <Row className="my-2">
      <Col xs={12}>
        <Form.Group className="mr-auto">
          <Form.Control
            type="text"
            value={search}
            onChange={searchHandler}
            placeholder="البحث عن متجر......"
            size="lg"
          />
        </Form.Group>
      </Col>

      <Col xs={12}>
        <hr />
      </Col>

      {search !== "" ? (
        <>
          <Col xs={12}>
            <h2 className="text-right">نتيجة البحث:</h2>
          </Col>
          {searchResult.map((s) => (
            <StoreCard store={s} key={s.id} />
          ))}
        </>
      ) : (
        <>
          <Col xs={12}>
            <h2 className="text-right">المتاجر الأكثر زيارة:</h2>
          </Col>
          {stores.map((s) =>
            s.topStore ? <StoreCard store={s} key={s.id} /> : ""
          )}
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h2 className="text-right">كل المتاجر:</h2>
          </Col>
          {stores.map((s) => (
            <StoreCard store={s} key={s.id} />
          ))}
        </>
      )}
    </Row>
  );
};

export default StoresList;
